module.exports = __webpack_public_path__ + "img/logo-iduam.ec304e39.svg";